import {take, fork, put, select} from 'redux-saga/effects';
import {arcGISTravelModeTypes} from '@ace-de/eua-arcgis-rest-client';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as savrActionTypes from '../savrActionTypes';
import config from '../../config';

/**
 * Calculate the distance between pickup location and destination
 */
const calculatePickupLocationToDestinationDistance = function* calculatePickupLocationToDestinationDistance() {
    const {serviceManager} = yield select(state => state.application);
    const mapService = !config.IS_FALLBACK_SYSTEM
        ? serviceManager.loadService('arcGISRESTService')
        : serviceManager.loadService('googleMapsService');

    while (true) {
        const {payload} = yield take(savrActionTypes.CALCULATE_PICKUP_LOCATION_TO_DESTINATION_DISTANCE);
        const {serviceAssignmentId, destination, pickupLocation} = payload;

        // calculate the distance between pickup location and destination
        if (pickupLocation) {
            const routeData = !config.IS_FALLBACK_SYSTEM
                ? {
                    startingPoint: {
                        longitude: destination.longitude,
                        latitude: destination.latitude,
                    },
                    destination: {
                        longitude: pickupLocation.longitude,
                        latitude: pickupLocation.latitude,
                    },
                    travelModeType: arcGISTravelModeTypes.TRUCK_TRAVEL_TIME,
                    startTime: 'now',
                } : {
                    origin: {
                        location: {
                            latLng: {
                                latitude: destination?.latitude,
                                longitude: destination?.longitude,
                            },
                        },
                    },
                    destination: {
                        location: {
                            latLng: {
                                latitude: pickupLocation?.latitude,
                                longitude: pickupLocation?.longitude,
                            },
                        },
                    },
                    fields: ['routes.distanceMeters'],
                };

            yield fork(
                fetchRequest,
                savrActionTypes.FETCH_PICKUP_LOCATION_TO_DESTINATION_DISTANCE_REQUEST,
                mapService.getRoute,
                {...routeData},
            );

            const routeResponseAction = yield take([
                savrActionTypes.FETCH_PICKUP_LOCATION_TO_DESTINATION_DISTANCE_REQUEST_SUCCEEDED,
                savrActionTypes.FETCH_PICKUP_LOCATION_TO_DESTINATION_DISTANCE_REQUEST_FAILED,
            ]);

            if (!routeResponseAction.error) {
                const {response} = routeResponseAction.payload;
                let pickupLocationToDestinationDistance = null;
                const routeDTO = !config.IS_FALLBACK_SYSTEM ? response.arcGISRouteDTO : response.routes[0];
                pickupLocationToDestinationDistance = routeDTO?.totalKilometers
                    ? routeDTO.totalKilometers
                    : routeDTO?.distanceMeters
                        ? routeDTO.distanceMeters / 1000
                        : null;

                yield put({
                    type: savrActionTypes.SET_SAVR_PICKUP_LOCATION_TO_DESTINATION_DISTANCE,
                    payload: {pickupLocationToDestinationDistance, serviceAssignmentId},
                });
            }
        }
    }
};

export default calculatePickupLocationToDestinationDistance;
